import { render, staticRenderFns } from "./ilmoitus-form.vue?vue&type=template&id=8404ab4a&scoped=true&"
import script from "./ilmoitus-form.vue?vue&type=script&lang=ts&"
export * from "./ilmoitus-form.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8404ab4a",
  null
  
)

export default component.exports